// Translations for CertHolderBanner + Cert request modal + FB community card + FB badge.
// Used by components/CertHolderBanner.jsx and components/FBCommunityCard.jsx.

const TR = {
  sk: {
    // Banner
    elite_zdarma: "ELITNÝ KLUB · ZDARMO",
    for_holders: "pre držiteľov certifikátu SauberEko®",
    state_active: "Aktívne",
    state_pending: "Čaká na overenie",
    state_rejected: "Zamietnuté · skús znova",
    headline_q: "Máš certifikát",
    headline_company: "SauberEko®",
    headline_q_end: "?",
    headline_free: "PRO prístup máš ZADARMO NATRVALO.",
    desc: "Tigik a SauberEko® patria k sebe — tvoj reálny certifikát od nás je tvoj pas do plnej verzie aplikácie. Stačí zadať",
    desc_fields: "číslo certifikátu, meno a priezvisko",
    desc_mid: "z papierového dokumentu — overím to v evidencii a aktivujem ti",
    desc_full_pro: "plný PRO prístup",
    desc_end: ": orbital + TIG bez limitu, potrubár, komunita všetky kanály,",
    desc_ai: "AI poradca Sauberino (5 správ denne)",
    desc_badge: "a zlatý certifikovaný odznak ⭐ pri tvojom mene.",
    cta_activate: "Aktivovať zdarma",
    cta_resubmit: "Odoslať znova",
    cta_pending: "Čaká na schválenie",
    cta_see_badge: "Pozri svoj odznak",
    rejection_label: "Dôvod zamietnutia:",
    // Modal
    modal_tag: "CERTIFIKÁT SauberEko®",
    modal_title: "Aktivuj svoj elitný prístup",
    modal_sub: "Zadaj údaje presne tak ako sú vytlačené na tvojom papierovom certifikáte SauberEko®. Admin to porovná s evidenciou a do 24 h ti aktivuje PRO zdarma.",
    label_cert_no: "Číslo certifikátu *",
    placeholder_cert_no: "napr. Sa.Eko.Prs-2025-0042",
    hint_cert_no: "Skopíruj presne (vrátane bodiek a pomlčiek) z papierového certifikátu.",
    label_first: "Meno *",
    label_last: "Priezvisko *",
    placeholder_first: "Ján",
    placeholder_last: "Novák",
    label_note: "Poznámka (voliteľné)",
    placeholder_note: "Kedy a kde si certifikát získal, prípadne v ktorej firme momentálne robíš...",
    error_required: "Vyplň všetky 3 povinné polia.",
    error_send: "Chyba pri odoslaní",
    btn_submit: "Odoslať na overenie",
    btn_cancel: "Zrušiť",
    success_title: "Žiadosť odoslaná!",
    success_body: "Príde ti email keď to schválim. Zvyčajne to trvá do 24 hodín.",
    close: "Zatvoriť",
    // Lifetime certified holder line (public profile)
    lifetime_label: "DOŽIVOTNÝ DRŽITEĽ",
    lifetime_since: "od",
    lifetime_brand: "SauberEko® certifikátu",
  },
  en: {
    elite_zdarma: "ELITE CLUB · FREE",
    for_holders: "for SauberEko® certificate holders",
    state_active: "Active",
    state_pending: "Awaiting verification",
    state_rejected: "Rejected · try again",
    headline_q: "Do you hold a",
    headline_company: "SauberEko®",
    headline_q_end: " certificate?",
    headline_free: "Get PRO access FREE for life.",
    desc: "Tigik and SauberEko® go together — your real-world certificate is your pass to the full app. Just enter your",
    desc_fields: "certificate number, first and last name",
    desc_mid: "from the paper document — I'll verify it against our records and activate",
    desc_full_pro: "full PRO access",
    desc_end: ": orbital + TIG unlimited, pipefitter, community all channels,",
    desc_ai: "AI advisor Sauberino (5 messages/day)",
    desc_badge: "and a gold certified badge ⭐ next to your name.",
    cta_activate: "Activate free",
    cta_resubmit: "Resubmit",
    cta_pending: "Awaiting approval",
    cta_see_badge: "See your badge",
    rejection_label: "Rejection reason:",
    modal_tag: "SauberEko® CERTIFICATE",
    modal_title: "Activate your elite access",
    modal_sub: "Enter the details exactly as printed on your paper SauberEko® certificate. I'll match it against our records and activate PRO for free within 24 h.",
    label_cert_no: "Certificate number *",
    placeholder_cert_no: "e.g. Sa.Eko.Prs-2025-0042",
    hint_cert_no: "Copy exactly (including dots and dashes) from your paper certificate.",
    label_first: "First name *",
    label_last: "Last name *",
    placeholder_first: "John",
    placeholder_last: "Smith",
    label_note: "Note (optional)",
    placeholder_note: "When and where you got the certificate, current employer...",
    error_required: "Please fill in all 3 required fields.",
    error_send: "Submit failed",
    btn_submit: "Submit for verification",
    btn_cancel: "Cancel",
    success_title: "Request submitted!",
    success_body: "You'll get an email when I approve it. Usually within 24 hours.",
    close: "Close",
    lifetime_label: "LIFETIME HOLDER",
    lifetime_since: "since",
    lifetime_brand: "of the SauberEko® certificate",
  },
  cs: {
    elite_zdarma: "ELITNÍ KLUB · ZDARMA",
    for_holders: "pro držitele certifikátu SauberEko®",
    state_active: "Aktivní",
    state_pending: "Čeká na ověření",
    state_rejected: "Zamítnuto · zkus znovu",
    headline_q: "Máš certifikát",
    headline_company: "SauberEko®",
    headline_q_end: "?",
    headline_free: "PRO přístup máš ZDARMA NATRVALO.",
    desc: "Tigik a SauberEko® patří k sobě — tvůj reálný certifikát od nás je tvůj pas do plné verze aplikace. Stačí zadat",
    desc_fields: "číslo certifikátu, jméno a příjmení",
    desc_mid: "z papírového dokumentu — ověřím to v evidenci a aktivuji ti",
    desc_full_pro: "plný PRO přístup",
    desc_end: ": orbital + TIG bez limitu, potrubář, komunita všechny kanály,",
    desc_ai: "AI poradce Sauberino (5 zpráv denně)",
    desc_badge: "a zlatý certifikovaný odznak ⭐ vedle tvého jména.",
    cta_activate: "Aktivovat zdarma",
    cta_resubmit: "Odeslat znovu",
    cta_pending: "Čeká na schválení",
    cta_see_badge: "Podívej se na svůj odznak",
    rejection_label: "Důvod zamítnutí:",
    modal_tag: "CERTIFIKÁT SauberEko®",
    modal_title: "Aktivuj svůj elitní přístup",
    modal_sub: "Zadej údaje přesně tak, jak jsou vytištěny na tvém papírovém certifikátu SauberEko®. Admin to porovná s evidencí a do 24 h ti aktivuje PRO zdarma.",
    label_cert_no: "Číslo certifikátu *",
    placeholder_cert_no: "např. Sa.Eko.Prs-2025-0042",
    hint_cert_no: "Zkopíruj přesně (včetně teček a pomlček) z papírového certifikátu.",
    label_first: "Jméno *",
    label_last: "Příjmení *",
    placeholder_first: "Jan",
    placeholder_last: "Novák",
    label_note: "Poznámka (volitelné)",
    placeholder_note: "Kdy a kde jsi certifikát získal, případně ve které firmě nyní pracuješ...",
    error_required: "Vyplň všechna 3 povinná pole.",
    error_send: "Chyba při odeslání",
    btn_submit: "Odeslat na ověření",
    btn_cancel: "Zrušit",
    success_title: "Žádost odeslána!",
    success_body: "Přijde ti email, až to schválím. Obvykle do 24 hodin.",
    close: "Zavřít",
    lifetime_label: "DOŽIVOTNÍ DRŽITEL",
    lifetime_since: "od",
    lifetime_brand: "certifikátu SauberEko®",
  },
  de: {
    elite_zdarma: "ELITE-CLUB · GRATIS",
    for_holders: "für Inhaber des SauberEko®-Zertifikats",
    state_active: "Aktiv",
    state_pending: "Warte auf Prüfung",
    state_rejected: "Abgelehnt · erneut versuchen",
    headline_q: "Hast du ein",
    headline_company: "SauberEko®",
    headline_q_end: "-Zertifikat?",
    headline_free: "PRO-Zugang GRATIS auf Lebenszeit.",
    desc: "Tigik und SauberEko® gehören zusammen — dein echtes Zertifikat von uns ist dein Pass zur vollständigen App. Gib einfach",
    desc_fields: "Zertifikatsnummer, Vor- und Nachnamen",
    desc_mid: "vom Papierdokument ein — ich gleiche es mit den Aufzeichnungen ab und aktiviere",
    desc_full_pro: "vollen PRO-Zugang",
    desc_end: ": Orbital + TIG unbegrenzt, Pipefitter, Community alle Kanäle,",
    desc_ai: "KI-Berater Sauberino (5 Nachrichten/Tag)",
    desc_badge: "und ein goldenes Zertifikatsabzeichen ⭐ neben deinem Namen.",
    cta_activate: "Gratis aktivieren",
    cta_resubmit: "Erneut senden",
    cta_pending: "Warte auf Genehmigung",
    cta_see_badge: "Mein Abzeichen ansehen",
    rejection_label: "Ablehnungsgrund:",
    modal_tag: "SauberEko®-ZERTIFIKAT",
    modal_title: "Aktiviere deinen Elite-Zugang",
    modal_sub: "Gib die Daten genau so ein, wie sie auf deinem SauberEko®-Papierzertifikat aufgedruckt sind. Admin gleicht sie mit den Aufzeichnungen ab und aktiviert PRO innerhalb von 24 h kostenlos.",
    label_cert_no: "Zertifikatsnummer *",
    placeholder_cert_no: "z.B. Sa.Eko.Prs-2025-0042",
    hint_cert_no: "Genau kopieren (inkl. Punkte und Bindestriche) vom Papierzertifikat.",
    label_first: "Vorname *",
    label_last: "Nachname *",
    placeholder_first: "Hans",
    placeholder_last: "Müller",
    label_note: "Notiz (optional)",
    placeholder_note: "Wann und wo hast du das Zertifikat erhalten, ggf. aktueller Arbeitgeber...",
    error_required: "Fülle alle 3 Pflichtfelder aus.",
    error_send: "Senden fehlgeschlagen",
    btn_submit: "Zur Prüfung senden",
    btn_cancel: "Abbrechen",
    success_title: "Anfrage gesendet!",
    success_body: "Du erhältst eine E-Mail, sobald ich es genehmige. Normalerweise innerhalb von 24 Stunden.",
    close: "Schließen",
    lifetime_label: "INHABER AUF LEBENSZEIT",
    lifetime_since: "seit",
    lifetime_brand: "des SauberEko®-Zertifikats",
  },
  pl: {
    elite_zdarma: "KLUB ELITY · ZA DARMO",
    for_holders: "dla posiadaczy certyfikatu SauberEko®",
    state_active: "Aktywne",
    state_pending: "Oczekuje na weryfikację",
    state_rejected: "Odrzucone · spróbuj ponownie",
    headline_q: "Masz certyfikat",
    headline_company: "SauberEko®",
    headline_q_end: "?",
    headline_free: "Dostęp PRO ZA DARMO NA ZAWSZE.",
    desc: "Tigik i SauberEko® idą w parze — twój prawdziwy certyfikat od nas to przepustka do pełnej wersji aplikacji. Wystarczy podać",
    desc_fields: "numer certyfikatu, imię i nazwisko",
    desc_mid: "z papierowego dokumentu — sprawdzę to w ewidencji i aktywuję ci",
    desc_full_pro: "pełny dostęp PRO",
    desc_end: ": orbital + TIG bez limitu, pipefitter, społeczność wszystkie kanały,",
    desc_ai: "doradca AI Sauberino (5 wiadomości dziennie)",
    desc_badge: "oraz złota odznaka certyfikowana ⭐ obok twojego imienia.",
    cta_activate: "Aktywuj za darmo",
    cta_resubmit: "Wyślij ponownie",
    cta_pending: "Oczekuje na akceptację",
    cta_see_badge: "Zobacz swoją odznakę",
    rejection_label: "Powód odrzucenia:",
    modal_tag: "CERTYFIKAT SauberEko®",
    modal_title: "Aktywuj swój elitarny dostęp",
    modal_sub: "Wprowadź dane dokładnie tak, jak są wydrukowane na twoim papierowym certyfikacie SauberEko®. Admin porówna to z ewidencją i w ciągu 24 h aktywuje PRO za darmo.",
    label_cert_no: "Numer certyfikatu *",
    placeholder_cert_no: "np. Sa.Eko.Prs-2025-0042",
    hint_cert_no: "Skopiuj dokładnie (włącznie z kropkami i myślnikami) z papierowego certyfikatu.",
    label_first: "Imię *",
    label_last: "Nazwisko *",
    placeholder_first: "Jan",
    placeholder_last: "Nowak",
    label_note: "Notatka (opcjonalna)",
    placeholder_note: "Kiedy i gdzie zdobyłeś certyfikat, ewentualnie w jakiej firmie obecnie pracujesz...",
    error_required: "Wypełnij wszystkie 3 wymagane pola.",
    error_send: "Błąd wysyłania",
    btn_submit: "Wyślij do weryfikacji",
    btn_cancel: "Anuluj",
    success_title: "Wniosek wysłany!",
    success_body: "Otrzymasz e-mail, gdy zatwierdzę. Zwykle w ciągu 24 godzin.",
    close: "Zamknij",
    lifetime_label: "DOŻYWOTNI POSIADACZ",
    lifetime_since: "od",
    lifetime_brand: "certyfikatu SauberEko®",
  },
  fr: {
    // Banner
    elite_zdarma: "CLUB ÉLITE · GRATUIT",
    for_holders: "pour les titulaires du certificat SauberEko®",
    state_active: "Actif",
    state_pending: "En attente de vérification",
    state_rejected: "Refusé · réessaie",
    headline_q: "Tu as un certificat",
    headline_company: "SauberEko®",
    headline_q_end: " ?",
    headline_free: "Accès PRO GRATUIT À VIE.",
    desc: "Tigik et SauberEko® vont de pair — ton certificat réel délivré par nous est ton pass vers la version complète de l'app. Il suffit de saisir",
    desc_fields: "numéro de certificat, prénom et nom",
    desc_mid: "depuis le document papier — je vérifie dans les archives et j'active ton",
    desc_full_pro: "accès PRO complet",
    desc_end: " : orbital + TIG illimité, tuyauteur, communauté tous canaux,",
    desc_ai: "conseiller IA Sauberino (5 messages/jour)",
    desc_badge: "et badge doré certifié ⭐ à côté de ton nom.",
    cta_activate: "Activer gratuitement",
    cta_resubmit: "Renvoyer",
    cta_pending: "En attente d'approbation",
    cta_see_badge: "Voir ton badge",
    rejection_label: "Raison du refus :",
    // Modal
    modal_tag: "CERTIFICAT SauberEko®",
    modal_title: "Active ton accès élite",
    modal_sub: "Saisis les données exactement comme elles sont imprimées sur ton certificat papier SauberEko®. L'admin comparera avec les archives et activera ton PRO gratuit sous 24 h.",
    label_cert_no: "Numéro de certificat *",
    placeholder_cert_no: "ex. Sa.Eko.Prs-2025-0042",
    hint_cert_no: "Copie exactement (y compris les points et tirets) depuis le certificat papier.",
    label_first: "Prénom *",
    label_last: "Nom *",
    placeholder_first: "Jean",
    placeholder_last: "Dupont",
    label_note: "Note (facultatif)",
    placeholder_note: "Quand et où tu as obtenu le certificat, ou dans quelle entreprise tu travailles actuellement...",
    error_required: "Remplis les 3 champs obligatoires.",
    error_send: "Erreur lors de l'envoi",
    btn_submit: "Envoyer pour vérification",
    btn_cancel: "Annuler",
    success_title: "Demande envoyée !",
    success_body: "Tu recevras un email quand je l'approuverai. Ça prend généralement moins de 24 heures.",
    close: "Fermer",
    // Lifetime certified holder line (public profile)
    lifetime_label: "TITULAIRE À VIE",
    lifetime_since: "depuis",
    lifetime_brand: "du certificat SauberEko®",
  },
};

export default TR;
